import React from "react";
import TriangleParticles from "../animations/particules/TriangleParticles";
import FormContent from "./FormContent";
import "./style.scss";

Banner01.propTypes = {};

function Banner01(props) {
  return (
    <section className="tf-slider sl1 parallax">
      <TriangleParticles />
      <div className="tf-container">
        <div className="row">
          <div className="col-lg-8 col-md-8">
            <FormContent />
          </div>
        </div>
      </div>
      <div className="overlay"></div>
    </section>
  );
}

export default Banner01;
